<template>
  <div
    :style="{
      'background-color': useBackgroundColor,
      'padding-top': paddingTop ? paddingTop + 'px' : '',
      'padding-bottom': paddingBottom ? paddingBottom + 'px' : ''
    }"
    :class="{ 'container': useContainer, 'redirect-block-select': blockParams?.isUrl }"
    @click="$emit('block:redirect')"
  >
    <div class="number-box">
      <div class="number-box__title">
        {{ mainFields?.title?.value }}
      </div>
      <!-- eslint-disable-next-line vue/no-v-html -->
      <div class="number-box__text" v-html="mainFields?.text?.value" />
    </div>
  </div>
</template>

<script>
import staticBlockMixin from '~/mixins/staticBlockMixin'

export default {
  name: 'InfoBalloon',
  mixins: [staticBlockMixin]
}
</script>
